import React, { useContext, useState} from 'react';
import { Row, Col, Button} from "design-react-kit";
import { SubscriberAuthContext } from 'services/auth_subscriber';
import { getCookie } from 'pa_kit/services/manage_cookies';


const NoSubBanner = () => {

    const subscriber_auth = useContext(SubscriberAuthContext);

    const cookieConsent = getCookie('CookieConsent');

    const [hideNoSubBanner, setHideNoSubBanner] = useState(() => {
        return localStorage.getItem("hideNoSubBanner") === "true";
    });

    const handleHideNoSubBanner = () => {
        localStorage.setItem("hideNoSubBanner", "true");
        setHideNoSubBanner(true);
    }

    if(!subscriber_auth.isCompany && !subscriber_auth.isApplicant) {
        return <>
            <div className={`nosub-banner-wrapper ${cookieConsent ? "" : "nosub-banner-margin"} ${hideNoSubBanner ? "" : "position-fixed"}`.trim()}>
                <Row>
                    <Col className="nosub-banner-col">
                        <div className="nosub-banner-text mb-2">Registrati per iniziare a cercare o offrire lavoro!</div>
                        <div>
                            <Button href="/registration/" className="btn btn-nosub-banner">Registrati</Button>
                            {!hideNoSubBanner &&
                                <Button type="button" className="btn-simple" onClick={() => handleHideNoSubBanner()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                                    </svg>
                                </Button>
                            }                            
                        </div>
                    </Col>
                </Row>             
            </div>
        </>;
    }
}

export default NoSubBanner;